export default "__VITE_ASSET__C1BvxIo4__"